import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * AppHeader — sticky top header with optional back button.
 * Variant glass for the PWA, solid for admin.
 */
export function AppHeader({
    title,
    subtitle,
    onBack,
    showBack = false,
    right,
    left,
    variant = "glass",
    className = "",
    testId,
}) {
    const navigate = useNavigate();
    const handleBack = onBack || (() => navigate(-1));
    const base = variant === "glass" ? "md-glass" : "bg-md-surface";
    return (
        <header
            data-testid={testId || "app-header"}
            className={`sticky top-0 z-40 ${base} border-b border-md-border pt-safe ${className}`}
        >
            <div className="flex items-center gap-3 px-4 py-3">
                <div className="min-w-0 flex-1 flex items-center gap-3">
                    {showBack ? (
                        <button
                            onClick={handleBack}
                            aria-label="Retour"
                            data-testid="app-header-back"
                            className="inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-md-surface-2 transition-colors"
                        >
                            <ArrowLeft className="h-5 w-5 text-md-text" />
                        </button>
                    ) : (
                        left || null
                    )}
                    <div className="min-w-0">
                        {title && (
                            <h1 className="truncate font-semibold tracking-tight text-md-text">
                                {title}
                            </h1>
                        )}
                        {subtitle && (
                            <p className="truncate text-xs text-md-text-2">{subtitle}</p>
                        )}
                    </div>
                </div>
                {right && <div className="shrink-0">{right}</div>}
            </div>
        </header>
    );
}

export default AppHeader;
